// src/components/Testimonial.js
import React, { useEffect, useState, useCallback } from "react";
import SEO from "../components/SEO";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  query,
  orderBy,
} from "firebase/firestore";
import "bootstrap/dist/css/bootstrap.min.css";

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    role: "",
    text: "",
    rating: "5",
  });
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const testimonialsRef = collection(db, "testimonials");

  // useCallback to avoid useEffect warning
  const fetchTestimonials = useCallback(async () => {
    try {
      const q = query(testimonialsRef, orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
      }));
      setTestimonials(data);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  }, [testimonialsRef]);

  useEffect(() => {
    fetchTestimonials();
  }, [fetchTestimonials]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.role || !formData.text) return;

    setLoading(true);

    try {
      await addDoc(testimonialsRef, {
        ...formData,
        rating: parseInt(formData.rating),
        createdAt: serverTimestamp(),
      });

      setTimeout(fetchTestimonials, 1000); // Give Firestore time to update
      setFormData({ name: "", role: "", text: "", rating: "5" });
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error("Error submitting testimonial:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        title="Student Testimonials - Adeleke Tennis Academy"
        description="Read reviews and testimonials from students who have trained with Julius Adeleke at Adeleke Tennis Academy."
        keywords="Tennis Student Reviews, Adeleke Tennis Academy Testimonials, Julius Adeleke Reviews"
        url="https://www.adeleketennisacademy.com/testimonial"
        image="https://julius-s-adeleke.web.app/public/julius.jpg"
      />

    <div className="mt-5 container my-5 bg-black p-4 rounded shadow">
      <h2 className="text-center mb-4 text-white" style={{
      marginTop: "20px"
    }}>What My Students Say</h2>

      {showSuccess && (
        <div className="alert alert-success text-center" role="alert">
          ✅ Thank you! Your review has been submitted.
        </div>
      )}

      <div className="row">
        {testimonials.map((item) => (
          <div className="col-12 mb-4" key={item.id}>
            <div className="card shadow-sm p-3 border-0" style={{ backgroundColor: "#fff" }}>
              <div className="card-body">
                <p className="fst-italic mb-3 text-dark">"{item.text}"</p>
                <h5 className="card-title mb-1">{item.name}</h5>
                <p className="text-muted mb-2">{item.role}</p>
                <div className="mb-2">
                  {[...Array(5)].map((_, i) => (
                    <span key={i} className={`me-1 ${i < item.rating ? "text-warning" : "text-secondary"}`}>★</span>
                  ))}
                </div>
                <small className="text-muted">Rated {item.rating} Stars</small>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h4 className="text-center mt-5 mb-4 text-white">Submit Your Review</h4>
      <form className="mx-auto" style={{ maxWidth: "600px" }} onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label text-white">Name:</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label text-white">Role:</label>
          <input
            type="text"
            className="form-control"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label text-white">Message:</label>
          <textarea
            className="form-control"
            rows="3"
            name="text"
            value={formData.text}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="mb-3">
          <label className="form-label text-white">Rating:</label>
          <select
            className="form-select"
            name="rating"
            value={formData.rating}
            onChange={handleChange}
          >
            <option value="5">5 Stars</option>
            <option value="4">4 Stars</option>
            <option value="3">3 Stars</option>
            <option value="2">2 Stars</option>
            <option value="1">1 Star</option>
          </select>
        </div>
        <div className="d-grid">
          <button type="submit" className="btn btn-light" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Submitting...
              </>
            ) : (
              "Submit Review"
            )}
          </button>
        </div>
      </form>
    </div>
    </>
  );
};

export default Testimonial;
